import { Entity, PrimaryGeneratedColumn, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, ManyToOne, JoinColumn, OneToMany } from "typeorm";
import { Countries } from "../countries/countries.entity";
import { OcaenFreightRatesEntity } from "../ocaen-freights-rates/ocean-freights-entity";

@Entity('freights_company')
export class FreightsCompany {
  
  @PrimaryGeneratedColumn("increment",{name:'id'})
  id:number;
  
  @Column("varchar",{
    nullable: false,
    name:"name"
    })
  name:string;

  
  @Column("varchar",{
    nullable: false,
    name:"code"
    })
  code:string;

  @Column("varchar",{
    // nullable: false,
    name:"liner_address"
    })
  linerAddress:string;

  @Column("boolean",{
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "created_user"
  })
  createdUser: string | null;

  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: string | null;
  
  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @OneToMany(type => OcaenFreightRatesEntity, info => info.linerInfo, { cascade: true })
    ocaenFreightsInfo: OcaenFreightRatesEntity[];
  }
